import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { FaEye, FaSearch } from "react-icons/fa";
import { FiDownload, FiFilter } from "react-icons/fi";

const allTransactions = [
  {
    id: 1,
    transactionId: "524654656534",
    type: "Mint",
    user: "Admin (System)",
    amount: "50.00 VTSG",
    date: "09-10-2025",
    time: "09:12 AM",
    status: "COMPLETED"
  },
  {
    id: 2,
    transactionId: "524654686514",
    type: "Transfer",
    user: "John Smith",
    amount: "50.00 VTSG",
    date: "09-10-2025",
    time: "09:12 AM",
    status: "Pending"
  },
  {
    id: 3,
    transactionId: "524754656514",
    type: "Buy",
    user: "Sarah Johnson",
    amount: "50.00 VTSG",
    date: "09-10-2025",
    time: "09:12 AM",
    status: "Processing"
  },
  {
    id: 4,
    transactionId: "465554656514",
    type: "Redeem",
    user: "Michael Brown",
    amount: "50.00 VTSG",
    date: "09-10-2025",
    time: "09:12 AM",
    status: "COMPLETED"
  },
  {
    id: 5,
    transactionId: "5246736656514",
    type: "Sell",
    user: "Emily Davis",
    amount: "50.00 VTSG",
    date: "09-10-2025",
    time: "09:12 AM",
    status: "COMPLETED"
  },
  {
    id: 6,
    transactionId: "527814656514",
    type: "Mint",
    user: "Admin (System)",
    amount: "50.00 VTSG",
    date: "09-10-2025",
    time: "09:12 AM",
    status: "COMPLETED"
  }
];

const getStatusChip = (status) => {
  const base = "text-xs font-semibold px-2 py-1 rounded-full border";
  switch (status) {
    case "COMPLETED":
      return (
        <span
          className={`${base} text-[#2CA62D] border-[#2CA62D] bg-[#DCF0DC]`}
        >
          ● COMPLETED
        </span>
      );
    case "Pending":
      return (
        <span
          className={`${base} text-[#804100] border-[#804100] bg-[#F6DEC5]`}
        >
          ● Pending
        </span>
      );
    case "Processing":
      return (
        <span
          className={`${base} text-[#003265] border-[#54A5F5] bg-[#E6F2FE]`}
        >
          ● Processing
        </span>
      );
    default:
      return status;
  }
};

const getTypeColor = (type) => {
  const base = "text-xs font-medium px-2 py-1 border rounded-full";
  switch (type) {
    case "Mint":
      return `${base} bg-[#FEF6E6] border-[#F6BF55] text-[#664300]`;
    case "Transfer":
      return `${base} bg-[#F2ECFC] border-[#D8C3F5] text-[#5B2B9E]`;
    case "Buy":
      return `${base} bg-[#E6F2FE] border-[#54A5F5] text-[#003265]`;
    case "Redeem":
      return `${base} bg-[#EDF5EB] border-[#C8DAC4] text-[#356D28]`;
    case "Sell":
      return `${base} bg-[#FFF0F0] border-[#880000] text-[#880000]`;
    default:
      return base;
  }
};

const TransactionHistory = () => {
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [page, setPage] = useState(0);

  const filteredRows = allTransactions.filter((txn) => {
    const matchesSearch =
      txn.transactionId.includes(searchText) ||
      txn.user.toLowerCase().includes(searchText.toLowerCase());
    const matchesStatus = filterStatus === "All" || txn.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const columns = [
    { field: "transactionId", headerName: "Transaction ID", flex: 2 },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      renderCell: ({ value }) => (
        <span className={getTypeColor(value)}>{value}</span>
      )
    },
    { field: "user", headerName: "User", flex: 2 },
    { field: "amount", headerName: "Amount", flex: 1 },
    {
      field: "datetime",
      headerName: "Date and time",
      flex: 2,
      valueGetter: (params) => `${params.row.date} ${params.row.time}`
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      renderCell: ({ value }) => getStatusChip(value)
    },
    {
      field: "action",
      headerName: "Active",
      flex: 1,
      renderCell: () => <FaEye className="text-gray-600" />
    }
  ];

  const handleExport = (rows) => {
    const headers = [
      "Transaction ID",
      "Type",
      "User",
      "Amount",
      "Date",
      "Time",
      "Status"
    ];
    const csv = [
      headers.join(","),
      ...rows.map((row) =>
        [
          row.transactionId,
          row.type,
          row.user,
          row.amount,
          row.date,
          row.time,
          row.status
        ].join(",")
      )
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "transaction-history.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className=" w-full">
      <div className="flex  gap-4 justify-between mb-6">
        <h2 className="font-poppins font-semibold text-24 leading-5">
          Transaction History
        </h2>
        <div className="flex gap-4">
          <div className="relative w-full ">
            <input
              type="text"
              placeholder="Search"
              className="w-full pl-4 pr-10 py-2 border border-primary-100 rounded-md"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <FaSearch className="absolute top-1/2 right-3 -translate-y-1/2 text-gray-500" />
          </div>

          <select
            className="px-4 py-2 border bg-transparent border-primary-100 rounded-md w-1/2"
            value={filterStatus}
            onChange={(e) => {
              setFilterStatus(e.target.value);
              setPage(0);
            }}
          >
            <option value="All">All</option>
            <option value="COMPLETED">Completed</option>
            <option value="Pending">Pending</option>
            <option value="Processing">Processing</option>
          </select>
          <button
            className="flex items-center gap-2 border border-primary-100 px-4 py-2 rounded-md hover:bg-gray-100"
            onClick={() => alert(" here")}
          >
            <FiFilter />
            Filter
          </button>

          {/* Export Button */}
          <button
            className="flex items-center gap-2 border border-primary-100 px-4 py-2 rounded-md hover:bg-gray-100"
            onClick={() => handleExport(filteredRows)}
          >
            <FiDownload />
            Export
          </button>
        </div>
      </div>

      <div className="h-[380px] w-full bg-white  shadow-lg rounded-lg">
        <DataGrid
          rows={filteredRows}
          columns={columns}
          getRowId={(row) => row.id}
          pageSizeOptions={[5]}
          paginationModel={{ pageSize: 5, page }}
          onPaginationModelChange={(model) => setPage(model.page)}
          rowCount={filteredRows.length}
          pagination
          sx={{
            fontFamily: "Poppins, sans-serif", // Font for grid
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#F9F4E8", // Light gray bg
              fontWeight: 500,
              fontSize: "16px",
              color: "#000000" // text-gray-900
            },
            "& .MuiDataGrid-cell": {
              fontSize: "16px",
              fontWeight: 500,
            }
          }}
        />
      </div>
    </div>
  );
};

export default TransactionHistory;
